import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col justify-center items-center" }
const _hoisted_2 = { class: "tour-key-area py-4" }
const _hoisted_3 = { class: "max-w-5xl flex flex-col md:flex-row justify-center items-center md:items-end pt-4 pb-6 gap-6" }
const _hoisted_4 = { class: "flex flex-col justify-center items-center gap-3" }
const _hoisted_5 = { class: "tour-firmware-btns join w-64" }

import { JSONSchemaType } from "ajv";
import { ref } from "vue";
import { webUsbSupported } from "@/utils";
import { LocalStorage } from "@/localStorage";
import { useKeyboardStore, useHighlightStore } from "@/stores";
import ListSwitcher from "@/components/utils/ListSwitcher.vue";
import KeyboardArea from "@/components/keys/KeyboardArea.vue";
import CompileFirmwareButton from "@/components/CompileFirmwareButton.vue";
import DownloadFirmwareButton from "@/components/DownloadFirmwareButton.vue";
import FlashFirmwareButton from "@/components/FlashFirmwareButton.vue";

// Switch button sizes after this time of hovering
const BUTTON_SWITCH_DELAY = 100;
type DownloadVariant = "DOWNLOAD" | "FLASH";


export default /*@__PURE__*/_defineComponent({
  __name: 'KeysArea',
  setup(__props) {

const SCHEMA: JSONSchemaType<DownloadVariant> = {
  type: "string",
  enum: ["DOWNLOAD", "FLASH"],
};
const noop = (v: DownloadVariant) => v;
const STORAGE = new LocalStorage("download-variant", SCHEMA, noop, noop);

const initialDownloadVariant = () => {
  if (!webUsbSupported()) {
    STORAGE.set("DOWNLOAD");
    return "DOWNLOAD";
  }
  return STORAGE.get() ?? "FLASH";
};

const kb = useKeyboardStore();
const hl = useHighlightStore();
let timer: number | undefined;

const downloadVariant = ref<DownloadVariant>(initialDownloadVariant());

const onMouseOver = (variant: DownloadVariant) => {
  if (timer == undefined) {
    const onTimeout = () => {
      downloadVariant.value = variant;
      if (webUsbSupported()) STORAGE.set(variant);
    };
    timer = setTimeout(onTimeout, BUTTON_SWITCH_DELAY);
  }
};

const onMouseLeave = (_variant: DownloadVariant) => {
  clearTimeout(timer);
  timer = undefined;
  if (!webUsbSupported()) downloadVariant.value = "DOWNLOAD";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(KeyboardArea, { class: "max-w-sm min-[450px]:max-w-md sm:max-w-screen-sm md:max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl overflow-x-scroll lg:overflow-x-visible" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(ListSwitcher, {
        class: "tour-layer-switcher border border-base-300 rounded-lg shadow py-3 pb-4 px-6 w-full h-full md:min-w-[32rem]",
        title: "Layers",
        entries: _unref(kb).availableLayers.map(String),
        current: _unref(kb).layer,
        onSelect: _cache[0] || (_cache[0] = (layer) => _unref(kb).setLayer(layer)),
        onInsert: _cache[1] || (_cache[1] = (layer) => _unref(kb).addLayer(layer)),
        onDelete: _cache[2] || (_cache[2] = (layer) => _unref(kb).removeLayer(layer)),
        noDelete: _unref(kb).layerCount == 1,
        isHighlighted: (id) => _unref(hl).isHighlightedLayer(_unref(kb).availableLayers[id])
      }, null, 8, ["entries", "current", "noDelete", "isHighlighted"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(CompileFirmwareButton, { class: "tour-compile-btn w-64" }),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(DownloadFirmwareButton, {
            onMouseover: _cache[3] || (_cache[3] = ($event: any) => (onMouseOver('DOWNLOAD'))),
            onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (onMouseLeave('DOWNLOAD'))),
            class: _normalizeClass(["transition-all", downloadVariant.value == 'DOWNLOAD' ? 'flex-grow' : '']),
            small: downloadVariant.value != 'DOWNLOAD'
          }, null, 8, ["class", "small"]),
          _createVNode(FlashFirmwareButton, {
            onMouseover: _cache[5] || (_cache[5] = ($event: any) => (onMouseOver('FLASH'))),
            onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (onMouseLeave('FLASH'))),
            class: _normalizeClass(["transition-all", [
              downloadVariant.value == 'FLASH' ? 'flex-grow' : '',
              _unref(webUsbSupported)() ? 'better-border-l' : '',
            ]]),
            small: downloadVariant.value != 'FLASH'
          }, null, 8, ["class", "small"])
        ])
      ])
    ])
  ]))
}
}

})